import { SectionNav } from "./SectionNav";
import { DEFINE_SLOTS } from "./sections";

// DEFINE — what good looks like, where we'll find them, and how we'll assess
// it. Sub-nav only for now; editors migrate in over Epic 0 stories #2216/#2217.
export function DefineSection() {
  return <SectionNav slots={DEFINE_SLOTS} ariaLabel="DEFINE sections" />;
}
